module.exports = ".profile{\r\n    margin-top: 15px;\r\n    height: calc(100vh - 15px);\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/section/user/user-profile/user-profile.component.css
// module id = ./src/app/section/user/user-profile/user-profile.component.css
// module chunks = main